import React, {Component, forwardRef} from 'react';
import classNames from 'classnames';
import FJSliderInput from '../../../common/component/slider/FJSliderInput';
import FJDropDown from "fj-components/FJDropDown"
import InlineSVG from "react-inlinesvg";
import FJTriangleIcon from '../../../icon/zoom-arrow.svg';
import './FJZoomScale.less';
import FJLocalStore from "../../../store/FJLocalStore";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJUtil from "../../../util/FJUtil";

const ForwardTrigger = forwardRef(((props, ref) => {

  let {btnClass, zoomScale, active, style} = props;
  return (
    <div style={style} className={classNames(btnClass, {active}, 'u-tooltip-bottom')} ref={ref} tooltip={FJLocalStore._('zoom')}>
      <span className='c-zoom__btn-text c-zoom__btn-text-value'>{Math.floor(zoomScale) + '%'}</span>
      <InlineSVG src={FJTriangleIcon} element='div'/>
    </div>
  );
}));

class FJZoomScale extends Component {

  constructor(props) {
    super(props);
    this.slider = React.createRef();
    this.dropDown = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.zoomScale !== this.props.zoomScale) {
      this._updateZoomScale(this.props.zoomScale);
    }

    if (!this._isDraging) {
      this.fitPosition();
    }
  };

  componentWillUnmount() {
  }

  _isDraging = false;

  fitPosition = () => {
    this.dropDown.current.fitPosition();
  };
  _popupPanelShowCallback = () => {
    this._updateZoomScale(this.props.zoomScale);
  };
  _updateZoomScale = (value) => {
    this.slider.current.updateSlider(Math.floor(value));
  };
  _zoomScaleDataChange = (data) => {
    switch (data.type) {
      case 'slideStart':
        this._isDraging = true;
        break;
      case 'changed':
        this._isDraging = true;
        break;
      case 'slideStop':
        this._isDraging = false;
        break;
      default:
        break;
    }
    this.props.zoomDataChange(data.type, data.value);
  };

  _fitClick = () => {
    this.props.adaptClick(FJCoreConstant.FIT)
  };

  _fillClick = () => {
    this.props.adaptClick(FJCoreConstant.FILL)
  };

  _toggleTooltip = (ele, bool) => {
    FJUtil.toggleTooltip(ele, bool);
  };

  render() {
    let {disabled = true, zoomScale, hasAdapt = true, style} = this.props;
    let btnClass = classNames('u-button-cursor c-zoom-container__btn', {disabled: disabled});
    return (
      <FJDropDown overlay={
        <div className="c-zoom-popup-panel">
          <FJSliderInput ref={this.slider}
                         sliderID='zoomSlider'
                         callback={this._zoomScaleDataChange}
                         showPercentage
                         name={FJLocalStore._('zoom')}
                         min={5}
                         max={200}
          />
          {
            hasAdapt ?   <div className='c-video-set-adapt'>
              <div className='c-video-set-adapt-btn' onClick={this._fitClick}>
                {FJLocalStore._('fit')}
              </div>
              <div className='c-video-set-adapt-btn' onClick={this._fillClick}>
                {FJLocalStore._('fill')}
              </div>
            </div> : null
          }

        </div>
      }
                  ref={this.dropDown}
                  useAnchorBody
                  isTopLayer
                  onShow={this._popupPanelShowCallback}
                  canTriggerActive
                  disabled={disabled}
                  overlayClassName='c-overlay-bg'
                  toggleTooltip={this._toggleTooltip}
                  hasArrow
      >
        <ForwardTrigger style={style} btnClass={btnClass} zoomScale={zoomScale} />
      </FJDropDown>
    );
  }
}

export default FJZoomScale;
